//import Button from "@mui/material/Button";
//import * as React from "react";
import React, {useEffect, useCallback, useRef, useState } from 'react';
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { Container, Alert, Typography, Button } from "@mui/material";
import { toPng } from 'html-to-image';
import axios from "axios";
import Barcode from 'react-barcode';
import { format } from "date-fns";
import {QRCodeSVG} from 'qrcode.react'




//import IconButton from "@mui/material/IconButton";

function GuiaImprimir() {
  const navigate = useNavigate();
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  //const username = userData?.username;
  //const clienteid = userData?.clienteid;
  //const empresaid = userData?.empresaid;
  //const imagen_cliente = userData?.imagen_cliente;
  const tipocuenta = userData?.tipocuenta; 
  const seguimientoIDActual = sessionStorage.getItem("seguimientoIDActual");
  //const seguimientoID = sessionStorage.getItem("seguimientoID");
  const [apiResponse, setApiResponse] = useState("");
  const [pedidos, setPedidos] = useState([]);
  
  //console.log(lastid);
  //console.log(seguimientoID);

 
  useEffect(() => {
  
  const loggedIn = sessionStorage.getItem("loggedIn");
       
    if (!loggedIn) {
      navigate("/login");
    }else{
      getPedidos();
    }
  }, [navigate]);

/*
  const [nombreOrigen, setnombreOrigen] = useState("");
  const [contactoOrigen, setcontactoOrigen] = useState("");
  const [direccionOrigen, setdireccionOrigen] = useState("");
  const [emailOrigen, setemailOrigen] = useState("");
  const [telefonoOrigen, settelefonoOrigen] = useState("");
  const [nombreDestino, setnombreDestino] = useState("");
  const [contactoDestino, setcontactoDestino] = useState("");
  const [direccionDestino, setdireccionDestino] = useState("");
  const [emailDestino, setemailDestino] = useState("");
  const [telefonoDestino, settelefonoDestino] = useState("");
  const [calleDestino, setcalleDestino] = useState("");
  const [numeroDestino, setnumeroDestino] = useState("");
  const [cpDestino, setcpDestino] = useState("");
  const [coloniaDestino, setcoloniaDestino] = useState("");
  const [alcaldiaDestino, setalcaldiaDestino] = useState("");
  const [referenciasDestino, setreferenciasDestino] = useState("");
  const [calleOrigen, setcalleOrigen] = useState("");
  const [numeroOrigen, setnumeroOrigen] = useState("");
  const [cpOrigen, setcpOrigen] = useState("");
  const [coloniaOrigen, setcoloniaOrigen] = useState("");
  const [alcaldiaOrigen, setalcaldiaOrigen] = useState("");
  const [referenciasOrigen, setreferenciasOrigen] = useState("");
*/
//test img


  const elementRef = useRef(null);

  const htmlToImageConvert = () => {
    toPng(elementRef.current, { cacheBust: false })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = seguimientoIDActual + "guia.png";
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  };
//test img


function getPedidos() {
  axios
  .post("https://boxerlogistica.com/api/envios_guia.php", {
    seguimientoID: seguimientoIDActual

  })
  .then(function(response){
   // console.log(response.data);
    setApiResponse(response.data.message);
    setPedidos(response.data.data);
  }); 
}

const dashboard = () => {
  if (tipocuenta!='Admin'){
    window.location.href = "/dashboard";
  }else{
    window.location.href = "/DashboardAdmin";
  }
};
    
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "5%",
      }}
    >
      
      <Container>
      <Alert
              style={{ marginBottom: "20px" }}
              severity="success" 
            >
              Imprimir Guia.
            </Alert> 
            {pedidos ? pedidos.map((pedido) =>
      <div className="guia" ref={elementRef} >
            <table className="guia-table" >
                <tr className="tr_guia_linea1">
                  <td>
                    <ul className="guia_f">        
                      <li><div className='box_guia1'><span></span></div></li>
                      <li>
                        <div className='box_guia2'>
                          <img src="/images/tel_ico.png"></img>5555555555<br></br>
                          <img src="/images/mail_ico.png"></img>ventas@boxerlogistica.com<br></br>
                          <img src="/images/web_ico.png"></img>www.boxerlogistica.com<br></br>
                        </div>
                      </li>            
                      <li><div className='box_guia3'>{format(pedido.creation_time, "dd-MM-yyyy")}<br></br>
                                {format(pedido.creation_time, "H:mma")}
                          </div>
                      </li>
                    </ul>
                 </td>
                </tr>
                <tr className="tr_guia_linea2">
                  <td>
                    <ul className="guia_f2">        
                      <li><div className='box_guia21'><span></span></div></li>
                      <li><div className='box_guia22'>
                            {pedido.proyecto}<br></br>
                            {pedido.sitio}<br></br>
                            {pedido.nombreOrigen}<br></br>
                            {pedido.contactoOrigen}<br></br>
                            {pedido.calleOrigen} {pedido.numeroOrigen}, 
                            {pedido.coloniaOrigen}, 
                            {pedido.alcaldiaOrigen}<br></br>
                            {pedido.cpOrigen}<br></br>
                            {pedido.referenciasOrigen}<br></br>
                            {pedido.telefonoOrigen}<br></br>
                            {pedido.emailOrigen}<br></br>
                            </div></li>            
                      <li><div className='box_guia23'><QRCodeSVG value={pedido.seguimientoIDP} size="80" />
                          </div>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr className="tr_guia_linea2">
                <td>
                    <ul className="guia_f2">        
                      <li><div className='box_guia21'><span></span></div></li>
                      <li><div className='box_guia22'>
                            {pedido.nombreDestino}<br></br>
                            {pedido.contactoDestino}<br></br>
                            {pedido.calleDestino}&nbsp {pedido.numeroDestino}<br></br>
                            {pedido.coloniaDestino}<br></br>
                            {pedido.alcaldiaDestino}<br></br>
                            {pedido.cpDestino}<br></br>
                            {pedido.telefonoDestino}<br></br>
                            {pedido.emailDestino}<br></br>
                            {pedido.referenciasDestino}<br></br>
                            </div></li>            
                      <li><div className='box_guia23'>
                          </div>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr className='tr_guia_linea3'>
                  <td>
                  <ul className="guia_f3">        
                      <li><div className='box_guia31'><span></span></div></li>            
                      <li>
                          <div className='box_guia32'>
                              {pedido.valor}<br></br>
                          </div>
                      </li>
                      <li>
                          <div className='box_guia33'>
                              {pedido.peso}<br></br>
                              </div>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr className='tr_guia_linea4'>
                  <td>
                  <ul className="guia_f4">        
                  <li><div className='box_guia41'><span></span></div></li> 
                      <li><div className='box_guia42'><Barcode value={pedido.seguimientoIDP} height="60" fontSize = "12" />;</div></li>            
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>
                    
                  
                  </td>
                </tr>
      </table>
      </div>
      ) : null }
      <button onClick={htmlToImageConvert}>Descargar Guia</button>
      <button onClick={dashboard}>Regresar</button>
      </Container>
    </Box>
  );
}




export default GuiaImprimir;



